import { autoinject } from 'aurelia-framework';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { Api } from 'app/shared/lib/api/api';
import { StandardLoadOptions } from 'app/shared/lib/essette-site';
import * as api from 'app/shared/lib/essette-api';
import * as Core from 'app/core/models/essette-api';

export interface IApiVersion {
    description?: string;
    version?: string;
    patch?: number;
    build?: number;
}

export interface IApiVersionMetadata {
    api?: IApiVersion;
    database?: IApiVersion;
}

@autoinject
export class AppService {

    private metadata: IApiVersionMetadata | null = null;

    constructor(private readonly api: Api, private readonly logger: AppLogger) {
        this.logger.source = this;
        this.logger.target = 'console';
    }

    public async getVersionMetadata(): Promise<IApiVersionMetadata> {
        if(this.metadata != null) {
            return this.metadata;
        }

        try {
            const query = this.api.query('meta/version').withTenant('system');
            const response = await this.api.get(query, { authenticate: false });
            if(response.isSuccessful && response.result && typeof response.result === 'object') {
                this.metadata = response.result;
            }
        }
        catch(e) {
            this.logger.error('Error loading API Metadata', e);
            throw e;
        }
        return this.metadata || {};
    }

    public async getApplicationModules(options?: StandardLoadOptions, includes: string[] = []): Promise<api.ApiQueryResponse<Core.ApplicationModule>> {

        const query = this.api
            .query(`/applications/modules`)
            .applyStandardLoadOptions(options)
            .include(...includes);

        return await this.api.get(query);
    }

}
